// Checked

import React, { useState, useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import flag8 from "../../../assets/images/flag8.png";
import TextField from "@material-ui/core/TextField";
import flag_bd4 from "../../../assets/images/flag_bd4.png";
import flag_usa4 from "../../../assets/images/flag_usa4.png";
import { TransferContext } from "../../../context/TransferContext";
import { Box, Checkbox, FormControlLabel } from "@material-ui/core";
import RefreshToken from "../../../components/RefreshToken";
import { AuthContext } from "../../../context/AuthContext";
import axios from "axios";

const useStyles = makeStyles(() => ({
  marginBottomStyle: {
    marginBottom: "10px",
  },

  inputStyle: {
    borderRadius: "8px",
  },
  inputStyle2: {
    borderRadius: "8px",
    // "& .MuiInputBase-input": {
    //   color: "#A2A2A2",
    // },
    "& .MuiSelect-outlined.MuiSelect-outlined": {
      fontSize: "14px",
      padding: 13,
    },
    "& .MuiSelect-select:focus": {
      backgroundColor: "#fff",
    },
  },
  textField: {
    [`& fieldset`]: {
      borderRadius: 8,
    },
    "& .MuiOutlinedInput-input": {
      fontSize: "14px",
    },
    "& .MuiOutlinedInput-inputMarginDense": {
      padding: 13,
    },
  },
  selectStyle: {
    textAlign: "left",

    "& img": {
      position: "relative",
      top: "2px",
      marginRight: "5px",
    },
  },
  selectItemStyle: {
    fontWeight: 600,
  },
  muteColor: {
    color: "#19181666",
  },
  inputRoot: {
    "& .MuiOutlinedInput-input": {
      // color: "green",
      // fontWeight: 600,
    },
    "& .MuiInputLabel-root": {
      // color: "green",
    },
    "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      // borderColor: "#eee",
      // backgroundColor: "#eee",
      color: "#333",
    },
    "&:hover .MuiOutlinedInput-input": {
      // color: "red",
    },
    "&:hover .MuiInputLabel-root": {
      // color: "red",
    },
    "&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      // borderColor: "red",
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-input": {
      // color: "purple",
    },
    "& .MuiInputLabel-root.Mui-focused": {
      // color: "purple",
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      // borderColor: "purple",
    },
  },
  flag: {
    marginRight: 10,
    width: 20,
    position: "relative",
    top: 4,
  },
  select: {
    "& .MuiSelect-select:focus": {
      backgroundColor: "#fff",
      borderWidth: 0,
    },
    "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      borderColor: "#fff",
    },
    padding: "5px",
    height: 45,
    borderRadius: 8,
  },
  file_button: {
    textTransform: "capitalize",
    color: "#999",
  },
}));
const SenderDetails = () => {
  const classes = useStyles();
  const { transfer, addToTransfer } = useContext(TransferContext);
  const { login, glob_pay_agent_auth, logout } = useContext(AuthContext);

  const [documentType, setDocumentType] = useState(5);
  const [create_account, set_create_account] = useState(false);
  const [fileInput, setfIleInput] = useState(null);

  const [fullName, setFullName] = useState(transfer.name || "");
  const [email, setemail] = useState(transfer.email);
  const [address, setAddress] = useState(transfer.address);
  const [passport, setPassport] = useState(transfer.passport);
  const [passportFrontPagePreview, setPassportFrontPagePreview] =
    useState(null);
  const [passportBackPagePreview, setPassportBackPagePreview] = useState(null);
  const [drivingLicenceFrontPagePreview, setDrivingLicenceFrontPagePreview] =
    useState(null);
  const [drivingLicenceBackPagePreview, setDrivingLicenceBackPagePreview] =
    useState(null);
  const [nidFrontPagePreview, setNidFrontPagePreview] = useState(null);
  const [nidBackPagePreview, setNidBackPagePreview] = useState(null);

  const [passportFrontPage, setPassportFrontPage] = useState(null);
  const [passportBackPage, setPassportBackPage] = useState(null);

  const [drivingLicence, setDrivingLicence] = useState(transfer.drivingLicence);
  const [drivingLicenceFrontPage, setDrivingLicenceFrontPage] = useState(null);
  const [drivingLicenceBackPage, setDrivingLicenceBackPage] = useState(null);
  const [nid, setNid] = useState(transfer.nid);
  const [nidFrontPage, setNidFrontPage] = useState(null);
  const [nidBackPage, setNidBackPage] = useState(null);

  const [documentId, setDocumentId] = useState(transfer.documentId);
  const [documentNumber, setDocumentNumber] = useState(transfer.documentNumber);
  const [mobileNumber, setMobileNumber] = useState(transfer.phone);
  const [phoneCode, setPhoneCode] = useState(
    transfer.fromCountry && transfer.fromCountry.code
  );

  const [flag, setFlag] = useState(
    transfer.fromCountry && transfer.fromCountry.flag
  );

  const [phone, setPhone] = useState(
    transfer.fromCountry && transfer.fromCountry.phone
  );

  const handleDocumentId = (e) => {
    const val = e.target.value;
    setDocumentId(val);
    addToTransfer({ documentId: val || undefined });
  };

  const handleDocumentNumber = (e) => {
    setDocumentNumber(e.target.value);
    addToTransfer({ documentNumber: e.target.value });
  };

  const HandleMobileNumber = (e) => {
    setMobileNumber(e.target.value);
    addToTransfer({ phone: e.target.value });
    addToTransfer({ mobileNumber: `${phone}${e.target.value}` });
  };

  const handlePhoneCode = (e) => {
    let value = e.target.value;
    let myValue = transfer.countries.filter((event) => event.code === value);
    console.log("new", myValue);
    setPhoneCode(myValue[0].code);
    setPhone(myValue[0].phone);

    // setPhoneCode(e.target.value);
    addToTransfer({ phoneCode: myValue[0].phone });
    addToTransfer({ mobileNumber: `${myValue[0].phone}${mobileNumber}` });
  };

  const handleAddress = (e) => {
    setAddress(e.target.value);
    addToTransfer({ address: e.target.value });
  };

  const handleCreateAccount = async () => {
    set_create_account(true);

    let token = await RefreshToken(glob_pay_agent_auth, logout, login);

    const nameParts = (fullName || "").trim().split(/\s+/);
    const firstName = nameParts[0] || "";
    const lastName = nameParts.slice(1).join(" ") || "";

    let data = new FormData();
    if (firstName) {
      data.append("firstName", firstName);
    }
    if (lastName) {
      data.append("lastName", lastName);
    }
    if (email) {
      data.append("email", email);
    }
    if (mobileNumber) {
      data.append("phone", mobileNumber);
    }
    if (address) {
      data.append("address", address);
    }

    if (passport) {
      data.append("passport", passport);
      data.append("passportFrontPage", passportFrontPage);
      data.append("passportBackPage", passportBackPage);
    }
    if (drivingLicence) {
      data.append("drivingLicence", drivingLicence);
      data.append("drivingLicenceFrontPage", drivingLicenceFrontPage);
      data.append("drivingLicenceBackPage", drivingLicenceBackPage);
    }

    if (nid) {
      data.append("nid", nid);
      data.append("nidFrontPage", nidFrontPage);
      data.append("nidBackPage", nidBackPage);
    }

    //   var formdata = new FormData();
    //   formdata.append("firstName", "Fahim");
    //   formdata.append("lastName", "Foysal");
    //   formdata.append("email", "foysal33@newroztech.ca");
    //   formdata.append("phone", "01846465446");
    //   formdata.append("address", "Mirpur");
    //   formdata.append("passport", "Passport_Verification");
    // //  return  console.log('image',fileInput )
    //   formdata.append("passportFrontPage", fileInput, "[PROXY]");
    //   formdata.append("passportBackPage", fileInput, "[PROXY]");
    //   formdata.append("drivingLicence", "Driving_Licence_Verification");
    //   formdata.append("drivingLicenceFrontPage", fileInput, "[PROXY]");
    //   formdata.append("drivingLicenceBackPage", fileInput, "[PROXY]");
    //   formdata.append("nid", "NID_Verification");
    //   formdata.append("nidFrontPage", fileInput, "[PROXY]");
    //   formdata.append("nidBackPage", fileInput, "[PROXY]");
    try {
      let res = await axios({
        url: `/api/v1/private/agent/request/personal-account`,
        method: "POST",
        data: data,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      console.log("send", res.data.data);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      {/* <Typography variant="h4" className={classes.marginBottomStyle}>
        Sender Details
      </Typography> */}
      <Grid container alignItems="center" spacing={3}>
        <Grid item xs={3}>
          <Typography variant="body1">Full Name</Typography>
        </Grid>
        <Grid item xs={9}>
          <TextField
            size="small"
            fullWidth
            placeholder="Enter Full Name"
            variant="outlined"
            className={classes.textField}
            value={fullName}
            onChange={(e) => {
              setFullName(e.target.value);
              addToTransfer({ name: e.target.value });
            }}
          />
        </Grid>
        <Grid item xs={3}>
          <Typography variant="body1">Email</Typography>
        </Grid>
        <Grid item xs={9}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <TextField
                size="small"
                fullWidth
                placeholder="Email"
                variant="outlined"
                className={classes.textField}
                value={email}
                onChange={(e) => {
                  setemail(e.target.value);
                  addToTransfer({ email: e.target.value });
                }}
              />
            </Grid>
          </Grid>
        </Grid>
        {/* end  */}
        <Grid item xs={3}>
          <Typography variant="body1">Address</Typography>
        </Grid>
        <Grid item xs={9}>
          <TextField
            id="address"
            size="small"
            fullWidth
            placeholder="Enter Address"
            variant="outlined"
            className={classes.textField}
            value={address}
            onChange={handleAddress}
          />
        </Grid>
        <Grid item xs={3}>
          <Typography variant="body1">Document Type</Typography>
        </Grid>
        <Grid item xs={9}>
          <FormControl variant="outlined" size="small" fullWidth>
            <TextField
              id="document-select-outlined"
              className={classes.inputStyle2}
              displayEmpty
              value={documentId || ""}
              onChange={handleDocumentId}
              variant="outlined"
              select
              InputProps={{
                className: classes.select,
              }}
            >
              <MenuItem value="" disabled>
                <span style={{ color: "#999" }}>Select One</span>
              </MenuItem>
              {transfer.documents &&
                transfer.documents.map((item, index) => (
                  <MenuItem value={item.id} key={index}>
                    {item.documentType}
                  </MenuItem>
                ))}
            </TextField>
          </FormControl>
        </Grid>
        <Grid item xs={3}>
          <Typography variant="body1">Document Number</Typography>
        </Grid>
        <Grid item xs={9}>
          <TextField
            id="document-number"
            size="small"
            fullWidth
            placeholder="Enter Id/Number"
            variant="outlined"
            className={classes.textField}
            value={documentNumber}
            onChange={handleDocumentNumber}
          />
        </Grid>
        <Grid item xs={3}>
          <Typography variant="body1">Mobile Number</Typography>
        </Grid>

        <Grid item xs={2}>
          <FormControl
            variant="outlined"
            className={classes.formControl}
            fullWidth
          >
            <TextField
              className={classes.inputRoot}
              displayEmpty
              defaultValue="na"
              value={phoneCode}
              onChange={handlePhoneCode}
              variant="outlined"
              select
              // disabled
              InputProps={{
                className: classes.select,
              }}
              size="small"
            >
              <MenuItem value="na" disabled>
                <span style={{ color: "#999" }}>Select code</span>
              </MenuItem>
              {transfer.countries.map((item, index) => (
                <MenuItem value={item.code} key={index}>
                  <img src={item.flag} alt="" className={classes.flag} />
                  {item.phone}
                </MenuItem>
              ))}
            </TextField>
          </FormControl>
        </Grid>
        <Grid item xs={7}>
          <TextField
            id="number"
            size="small"
            fullWidth
            variant="outlined"
            placeholder="Enter Mobile Number"
            className={classes.textField}
            value={mobileNumber}
            onChange={HandleMobileNumber}
          />
        </Grid>

        {/* document passport */}
        <Grid item xs={3}>
          <FormControlLabel
            control={
              <Checkbox
                // checked={state.checkedB}
                onChange={(e) => {
                  if (e.target.checked) {
                    setPassport(e.target.value);
                  } else {
                    setPassport("");
                  }
                }}
                name="Passport"
                color="primary"
                value="Passport_Verification"
              />
            }
            label="Passport"
          />
        </Grid>
        {passport ? (
          <React.Fragment>
            <Grid item xs={4}>
              <Box
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  gap: "10px",
                }}
              >
                <input
                  type="file"
                  accept="image/*"
                  onChange={(e) => {
                    let imageFile = e.target.files[0];
                    setPassportFrontPagePreview(URL.createObjectURL(imageFile));
                    setPassportFrontPage(imageFile);
                  }}
                />
                <Box>
                  {passportFrontPagePreview ? (
                    <img src={passportFrontPagePreview} height="100" />
                  ) : (
                    <Typography variant="h6">Passport Front Page</Typography>
                  )}
                </Box>
              </Box>
            </Grid>
            <Grid item xs={4}>
              <Box
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  gap: "10px",
                }}
              >
                <input
                  type="file"
                  onChange={(e) => {
                    let imageFile = e.target.files[0];

                    setPassportBackPagePreview(URL.createObjectURL(imageFile));
                    setPassportBackPage(imageFile);
                  }}
                />
                <Box>
                  {passportFrontPagePreview ? (
                    <img src={passportBackPagePreview} height="100" />
                  ) : (
                    <Typography variant="h6">Passport Back Page</Typography>
                  )}
                </Box>
              </Box>
            </Grid>
          </React.Fragment>
        ) : (
          <Grid item xs={9}></Grid>
        )}
        {/* document passport  */}

        {/* document drivingLicence */}
        <Grid item xs={3}>
          <FormControlLabel
            control={
              <Checkbox
                // checked={state.checkedB}
                onChange={(e) => {
                  if (e.target.checked) {
                    setDrivingLicence(e.target.value);
                  } else {
                    setDrivingLicence("");
                  }
                }}
                name="Driving Licence"
                color="primary"
                value="Driving_Licence_Verification"
              />
            }
            label="Driving Licence"
          />
        </Grid>
        {drivingLicence ? (
          <React.Fragment>
            <Grid item xs={4}>
              <Box
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  gap: "10px",
                }}
              >
                <input
                  type="file"
                  onChange={(e) => {
                    setDrivingLicenceFrontPagePreview(
                      URL.createObjectURL(e.target.files[0])
                    );
                    setDrivingLicenceFrontPage(e.target.files[0]);
                  }}
                />
                <Box>
                  {drivingLicenceFrontPagePreview ? (
                    <img src={drivingLicenceFrontPagePreview} height="100" />
                  ) : (
                    <Typography variant="h6">
                      Driving Licence Front Page
                    </Typography>
                  )}
                </Box>
              </Box>
            </Grid>
            <Grid item xs={4}>
              <Box
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  gap: "10px",
                }}
              >
                <input
                  type="file"
                  onChange={(e) => {
                    setDrivingLicenceBackPagePreview(
                      URL.createObjectURL(e.target.files[0])
                    );
                    setDrivingLicenceBackPage(e.target.files[0]);
                  }}
                />
                <Box>
                  {drivingLicenceBackPagePreview ? (
                    <img src={drivingLicenceBackPagePreview} height="100" />
                  ) : (
                    <Typography variant="h6">
                      Driving Licence Back Page
                    </Typography>
                  )}
                </Box>
              </Box>
            </Grid>
          </React.Fragment>
        ) : (
          <Grid item xs={9}></Grid>
        )}
        {/* document drivingLicence  */}

        {/* document nid */}
        <Grid item xs={3}>
          <FormControlLabel
            control={
              <Checkbox
                // checked={state.checkedB}
                onChange={(e) => {
                  if (e.target.checked) {
                    setNid(e.target.value);
                  } else {
                    setNid("");
                  }
                }}
                name="NID"
                color="primary"
                value="NID_Verification"
              />
            }
            label="NID"
          />
        </Grid>
        {nid ? (
          <React.Fragment>
            <Grid item xs={4}>
              <Box
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  gap: "10px",
                }}
              >
                <input
                  type="file"
                  onChange={(e) => {
                    setNidFrontPagePreview(
                      URL.createObjectURL(e.target.files[0])
                    );
                    setNidFrontPage(e.target.files[0]);
                  }}
                />
                <Box>
                  {nidFrontPagePreview ? (
                    <img src={nidFrontPagePreview} height="100" />
                  ) : (
                    <Typography variant="h6">NID Front Page</Typography>
                  )}
                </Box>
              </Box>
            </Grid>
            <Grid item xs={4}>
              <Box
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  gap: "10px",
                }}
              >
                <input
                  type="file"
                  onChange={(e) => {
                    setNidBackPagePreview(
                      URL.createObjectURL(e.target.files[0])
                    );
                    setNidBackPage(e.target.files[0]);
                  }}
                />
                <Box>
                  {nidBackPagePreview ? (
                    <img src={nidBackPagePreview} height="100" />
                  ) : (
                    <Typography variant="h6">NID Back Page</Typography>
                  )}
                </Box>
              </Box>
            </Grid>
          </React.Fragment>
        ) : (
          <Grid item xs={9}></Grid>
        )}
        {/* document nid  */}

        <Grid item xs={12}>
          <FormControlLabel
            control={
              <Checkbox
                checked={create_account}
                onChange={handleCreateAccount}
                name="checkedB"
                color="primary"
              />
            }
            label="Create new account"
          />
        </Grid>
      </Grid>
    </>
  );
};

export default SenderDetails;
